/* custom.js – TROTTA */

/* ==========================================================================
   TROTTA – mejoras de conversión (octubre 2026)
   1) Obliga a elegir talla antes de añadir al carrito o comprar ahora.
   2) Oculta el botón flotante de WhatsApp mientras el carrito lateral está abierto.
   3) Ubica la franja de métodos de pago (snippets/trotta-pagos.liquid) encima del botón de compra.
   Para desactivar todo, borrar este bloque completo.
   ========================================================================== */
(function () {
  'use strict';

  var SIZE_NAME = /tama|talla|size/i;

  /* ---------- Estilos ---------- */
  var css =
    'html.trotta-cart-open #wa-chat-btn-root{display:none !important;}' +
    'body:has(#mini-cart[aria-hidden="false"]) #wa-chat-btn-root{display:none !important;}' +
    '.trotta-size-error{display:none;margin:8px 0 0;color:var(--error-color,#d00);font-size:13px;}' +
    '.trotta-size-missing .trotta-size-error{display:block;}' +
    '.trotta-size-missing .block-swatch-list,.trotta-size-missing .select-wrapper{outline:2px solid var(--error-color,#d00);outline-offset:4px;border-radius:4px;}' +
    'form[data-trotta-size-pending] .trotta-inventory{display:none !important;}';
  var style = document.createElement('style');
  style.setAttribute('data-trotta', 'mejoras');
  style.appendChild(document.createTextNode(css));
  document.head.appendChild(style);

  /* ---------- 1) Talla obligatoria ---------- */
  function getSizeOption(form) {
    var options = form.querySelectorAll('.product-form__option');
    for (var i = 0; i < options.length; i++) {
      var nameEl = options[i].querySelector('.product-form__option-name');
      var radios = options[i].querySelectorAll('input[type="radio"]');
      if (nameEl && SIZE_NAME.test(nameEl.textContent) && radios.length > 1) {
        return options[i];
      }
    }
    return null;
  }

  function setupForm(form) {
    if (!form || form.getAttribute('data-trotta-ready')) return;
    form.setAttribute('data-trotta-ready', 'true');

    var option = getSizeOption(form);
    if (!option) return;

    var radios = option.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      radios[i].checked = false;
    }

    var selectedLabel = option.querySelector('.product-form__selected-value');
    if (selectedLabel) selectedLabel.textContent = 'Selecciona tu talla';

    var inventory = form.querySelector('.product-form__inventory');
    if (inventory) {
      var inventoryRow = inventory.closest('.product-form__info-item');
      if (inventoryRow) inventoryRow.classList.add('trotta-inventory');
    }

    var error = document.createElement('p');
    error.className = 'trotta-size-error';
    error.textContent = 'Por favor selecciona tu talla para continuar.';
    option.appendChild(error);

    form.setAttribute('data-trotta-size-pending', 'true');

    for (var j = 0; j < radios.length; j++) {
      radios[j].addEventListener('change', function () {
        form.removeAttribute('data-trotta-size-pending');
        option.classList.remove('trotta-size-missing');
      });
    }
  }

  function warn(form) {
    var option = getSizeOption(form);
    if (!option) return;
    option.classList.add('trotta-size-missing');
    try {
      option.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (e) {
      option.scrollIntoView();
    }
  }

  function isBlocked(form) {
    return !!(form && form.hasAttribute && form.hasAttribute('data-trotta-size-pending'));
  }

  window.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var button = target.closest('.product-form__add-button, .shopify-payment-button');
    if (!button) return;
    var form = button.closest('form');
    if (isBlocked(form)) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      warn(form);
    }
  }, true);

  window.addEventListener('submit', function (event) {
    var form = event.target;
    if (form && form.classList && form.classList.contains('product-form') && isBlocked(form)) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      warn(form);
    }
  }, true);

  function setupAll(root) {
    var forms = (root || document).querySelectorAll('form.product-form');
    for (var i = 0; i < forms.length; i++) setupForm(forms[i]);
  }

  /* ---------- 3) Franja de métodos de pago (ficha de producto) ---------- */
  function placePaymentStrip() {
    var template = document.getElementById('trotta-pagos-template');
    if (!template || !template.content) return;
    var container = document.querySelector('[data-section-type="product"] .product-form__payment-container');
    if (!container || container.parentNode.querySelector('.trotta-pagos')) return;
    container.parentNode.insertBefore(template.content.cloneNode(true), container);
  }

  /* ---------- 2) WhatsApp oculto con el carrito abierto ---------- */
  function watchCart() {
    var cart = document.getElementById('mini-cart');
    if (!cart || !window.MutationObserver) return;
    var update = function () {
      var open = cart.getAttribute('aria-hidden') === 'false';
      document.documentElement.classList.toggle('trotta-cart-open', open);
    };
    new MutationObserver(update).observe(cart, { attributes: true, attributeFilter: ['aria-hidden'] });
    update();
  }

  function init() {
    // Esperamos a que el tema termine su propia inicialización
    setTimeout(function () {
      placePaymentStrip();
      setupAll(document);
      watchCart();
    }, 0);

    // Formularios que aparecen después (vista rápida / compra rápida)
    if (window.MutationObserver) {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (node.nodeType !== 1) continue;
            if ((node.matches && node.matches('form.product-form')) || (node.querySelector && node.querySelector('form.product-form'))) {
              setTimeout(function () { setupAll(document); }, 400);
              return;
            }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
